import { type ResponseItemType } from '@/common/types/response.type';
import { useMutation } from '@tanstack/react-query';
import Client from '@/common/utils/client.utility';

export interface RegisterMutationParams {
  username: string;
}

interface RegisterResponse {
  phoneNumber: string;
  token: string;
}

export type RegisterType = (
  params: RegisterMutationParams
) => Promise<ResponseItemType<RegisterResponse>>;

const register: RegisterType = async (params) => {
  const client = new Client();
  return await client.post('/v1/Identity/Register/Customer', params);
};

export function useRegister() {
  return useMutation({
    mutationFn: async (params: RegisterMutationParams) =>
      await register(params),
  });
}
